import { useGetClientProfile } from '@/api/clients/get-client-profile'
import { PackagesListPage } from '@/pages/packages/packages-list'

import * as S from './packages.styled'
import { ClientProfilePackagesProps } from './packages.types'

export const Packages = ({ clientId }: ClientProfilePackagesProps) => {
  const { data: clientData, isLoading } = useGetClientProfile({ clientId })

  if (isLoading || !clientData) return null

  const resident = {
    apartment: clientData.apartment,
    buildingNumber: clientData.buildingNumber,
    id: Number(clientId),
    name: `${clientData.user.firstName} ${clientData.user.lastName}`,
  }

  return (
    <S.Container>
      <PackagesListPage resident={resident} building={clientData.buildingId} />
    </S.Container>
  )
}
